module.exports = __webpack_public_path__ + "img/S_icon.ce26da8d.png";